import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';

export const USER_CONTAINER_KEYS = [
  'freezer_contents',
  'freezer_door_contents',
  'fridge_level_contents',
  'fridge_door_contents',
  'crisper_left_contents',
  'crisper_right_contents',
  'pantry_contents',
  'spice_rack_contents',
  'other_contents',
];

const createEmptyFoodItem = () => ({
  id: '',
  name: '',
  quantity: '',
  expirationDate: '',
});

const createDefaultContainers = () =>
  USER_CONTAINER_KEYS.reduce((containers, key) => {
    containers[key] = [];
    return containers;
  }, {});

const getLegacyContainers = (containers = {}) => ({
  freezer_contents: containers.freezer ?? [],
  fridge_level_contents: containers.fridge ?? [],
  pantry_contents: containers.pantry ?? [],
  other_contents: containers.other ?? [],
});

export const createDefaultUserDatabase = (user) => ({
  email: user?.email ?? '',
  createdAt: new Date().toISOString(),
  containers: createDefaultContainers(),
});

export const normalizeUserDatabase = (data = {}) => {
  const containers = {
    ...getLegacyContainers(data.containers),
    ...(data.containers ?? {}),
  };
  const defaultContainers = createDefaultContainers();

  const normalizedContainers = Object.keys(defaultContainers).reduce(
    (accumulator, containerName) => {
      const items = Array.isArray(containers[containerName])
        ? containers[containerName]
        : [];

      accumulator[containerName] = items.map((item = {}) => ({
        ...createEmptyFoodItem(),
        ...item,
      }));

      return accumulator;
    },
    {}
  );

  return {
    ...data,
    containers: normalizedContainers,
  };
};

export async function initializeUserDatabase(user) {
  if (!user?.uid) return null;

  const userRef = doc(db, 'users', user.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    const defaultDatabase = createDefaultUserDatabase(user);
    await setDoc(userRef, defaultDatabase);
    return defaultDatabase;
  }

  const normalizedDatabase = normalizeUserDatabase(userSnap.data());
  await setDoc(userRef, normalizedDatabase, { merge: true });

  return normalizedDatabase;
}
